import { ProductUnit } from '../../../../../types/ProductUnit';
import { Text } from '../../../../cdl/Text/Text';
import { formatTotalPrice } from '../../../../common/helpers/formatTotal.helper';
import { Characters } from '../../../../common/helpers/unicode.helper';
import { Box } from '../../../../common/ui/Box';
import { PriceVolumeSubline } from '../PriceVolumeSubline';

import type { LineItemComparisonTotalCell } from './types/LineItemComparisonTotalCell';

type TotalCellContentProps = Pick<LineItemComparisonTotalCell, 'offeredVolume' | 'ppl' | 'total'>;

export const TotalCellContent = ({ offeredVolume, ppl, total }: TotalCellContentProps) => {
    if (!total) {
        return (
            <Box display="grid" rowGap={2} justifyItems="end">
                <Text fontWeight={600} color="foreground.subtle">
                    {Characters.EN_DASH}
                </Text>
            </Box>
        );
    }

    return (
        <Box display="grid" rowGap={2} justifyItems="end">
            <Text fontWeight={600}>{formatTotalPrice(total)}</Text>
            {ppl && offeredVolume !== undefined ? (
                <PriceVolumeSubline price={ppl} volume={offeredVolume} unit={ProductUnit.L} />
            ) : null}
        </Box>
    );
};
